//mui components
import {
  Button,
  Grid,
  IconButton,
  InputAdornment,
  Stack,
  Typography,
} from "@mui/material";

// components
import LoadingCM from "components/shared/Loading";

// static image
import logo from "assets/img/logo.png";

// helper
import Toast from "helper/toast";

// hooks
import useHttp from "hooks/use-http";
import { yupResolver } from "@hookform/resolvers/yup";
import { createPortal } from "react-dom";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { useState } from "react";

// mui config
import { MuiThemeProivider } from "styles/mui-config";
import RTL from "styles/rtl-config";

// validate
import { resetPasswordSchema } from "validations";

// styled cm
import {
  BackBtn,
  StyledContainer,
  StyledGrid,
  StyledImg,
  StyledTextField,
} from "./ResetPassword.style";

// icons
import { IoIosPerson } from "react-icons/io";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import { HiOutlineArrowRight } from "react-icons/hi";
import { resetPasswordRequest, resetTeacherPasswordRequest } from "api/requests";
import AuthContext from "store/auth-context";
import useAuth from "hooks/use-auth";

export default function ResetTeacherPassword() {
  const AuthCTX = useAuth();
  const { loading, setLoading, request } = useHttp(false);
  const navigate = useNavigate();
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(resetPasswordSchema),
  });

  // password visibility icon state
  const [toggle, setToggle] = useState({
    passwordVisibility: false,
    ConfirmPasswordVisibility: false,
  });

  // handle pass and confirm pass visibility
  const handleChangeVisibility = (action) => {
    if (action === "password") {
      setToggle((prev) => ({
        ...prev,
        passwordVisibility: !toggle.passwordVisibility,
      }));
    } else {
      setToggle((prev) => ({
        ...prev,
        ConfirmPasswordVisibility: !toggle.ConfirmPasswordVisibility,
      }));
    }
  };

  const onSubmit = async (data) => {
    const transformedData = { otp: data.otpCode, new_password: data.password };
    const res = await request({
      url: resetTeacherPasswordRequest,
      values: transformedData,
    });
    if (res) {
    Toast({ type: "success", title: "تغییر رمز ورود " });
    AuthCTX.logout();
    return navigate("/login");
    }
  };

  return loading ? (
    <LoadingCM />
  ) : (
    createPortal(
      <>
        <MuiThemeProivider>
          <RTL>
            <div dir="rtl">
              <Stack
                direction={{ xs: "column", md: "row" }}
                sx={{ background: "#fff", display: "flex" }}
                height="100vh"
                justifyContent={"center"}
              >
                <BackBtn>
                  <Stack px={{ md: 15, xs: 5 }}>
                    <IconButton onClick={() => navigate(-1)}>
                      <HiOutlineArrowRight />
                    </IconButton>
                  </Stack>
                </BackBtn>
                <Stack
                  justifyContent="center"
                  alignItems="center"
                  width="100%"
                  display={{ md: "none" }}
                >
                  <StyledImg src={logo} alt="" />
                </Stack>
                <StyledContainer container>
                  <Grid item xs={12} md={7} lg={6} p={{ xs: 5, md: 0 }}>
                    <Stack
                      px={{ md: 15 }}
                      height={"100%"}
                      justifyContent="center"
                      alignItems="center"
                      spacing={4}
                    >
                      <Typography
                        variant="h4"
                        component={"h2"}
                        fontWeight={"bold"}
                        color="primary"
                        fontFamily={"Aviny"}
                      >
                        تغییر رمز ورود
                      </Typography>
                      <StyledTextField
                        label="کد امنیتی"
                        variant="filled"
                        size="small"
                        fullWidth
                        id="otpCode"
                        {...register("otpCode")}
                        error={Boolean(errors.otpCode)}
                        helperText={errors.otpCode?.message}
                        InputProps={{
                          endAdornment: (
                            <InputAdornment position="end">
                              <IoIosPerson />
                            </InputAdornment>
                          ),
                        }}
                      />
                      <StyledTextField
                        label="کلمه عبور"
                        variant="filled"
                        size="small"
                        fullWidth
                        id="password"
                        name="password"
                        {...register("password")}
                        error={Boolean(errors.password)}
                        helperText={errors.password?.message}
                        type={toggle.passwordVisibility ? "text" : "password"}
                        InputProps={{
                          endAdornment: (
                            <InputAdornment position="end">
                              <IconButton
                                id="passwordVisibility"
                                aria-label="toggle password visibility"
                                onClick={() =>
                                  handleChangeVisibility("password")
                                }
                              >
                                {toggle.passwordVisibility ? (
                                  <Visibility />
                                ) : (
                                  <VisibilityOff />
                                )}
                              </IconButton>
                            </InputAdornment>
                          ),
                        }}
                      />
                      <StyledTextField
                        label="تکرار کلمه عبور"
                        variant="filled"
                        size="small"
                        fullWidth
                        id="confirm_password"
                        {...register("confirm_password")}
                        error={Boolean(errors.confirm_password)}
                        helperText={errors.confirm_password?.message}
                        type={
                          toggle.ConfirmPasswordVisibility ? "text" : "password"
                        }
                        InputProps={{
                          endAdornment: (
                            <InputAdornment position="end">
                              <IconButton
                                aria-label="toggle confirm_password visibility"
                                onClick={() =>
                                  handleChangeVisibility("confirmPassword")
                                }
                              >
                                {toggle.ConfirmPasswordVisibility ? (
                                  <Visibility />
                                ) : (
                                  <VisibilityOff />
                                )}
                              </IconButton>
                            </InputAdornment>
                          ),
                        }}
                      />
                      <Button
                        onClick={handleSubmit(onSubmit)}
                        variant="contained"
                        fullWidth
                        sx={{
                          fontFamily: "Aviny",
                          fontSize: "1.5rem",
                          padding: 0,
                        }}
                      >
                        تغییر رمز
                      </Button>
                    </Stack>
                  </Grid>
                  <StyledGrid item />
                </StyledContainer>
              </Stack>
            </div>
          </RTL>
        </MuiThemeProivider>
      </>,
      document.getElementById("login")
    )
  );
}
